
// Vue
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";


// Types
import { FilteredEvent } from "@/store/eventqueue/types";
import { FeaturesList } from "@/store/types";

// Namespaces
const Eventqueue = namespace("eventqueue");

@Component({})
export default class AlarmNotification extends Vue {
	// -- Vuex -- //
	@Eventqueue.State (state => state.FilteredEvents) filteredEvents: FilteredEvent[];

	@State featuresList: FeaturesList;

	// -- Computed Properties -- //
	public get events(): FilteredEvent[] {
		if (!this.filteredEvents) return [];

		return this.filteredEvents.filter(
			(q) => q.eventTypeID == 1 && q.inProcessing == false && q.unParkAt == null && q.isPermanentParked == false
		);
	}

	private get alarmStatusText(): string {
		if (this.events.length == 0) {
			return "Current Queue Status: No unanswered alarms in the queue."
		} else if (this.events.length == 1) {
			return `Current Queue Status: ${ this.events.length } unanswered alarm in the queue`
		} else {
			return `Current Queue Status: ${ this.events.length } unanswered alarms in the queue.`
		}
	}
}
